import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { mapStateToPropsWrapper } from '../CaptureErreurs';
import { Link } from 'react-router-dom';
import * as VotesAct from '../../Actions/VoteActions';
import { chargementComplet, chargementCommun } from '../../Actions/GlobalActions';
import { toDate, fromNow } from '../../App_Code/Utils';
import { validerVotes} from '../../App_Code/API';
import swal from 'sweetalert2';

class FicheSignature extends Component {
    constructor(props) {
        super(props);


        this.state = {
          lsvotes: this.props.lsvotes,
          NumReunion: this.props.NumReu,
          LieuSignature:"",
          NomSignature:"",
          erreur:false,
          Fait:this.props.Fait,
        };

    }

    componentWillMount() {
    }

  reinit = () => {
    // chargementCommun()
    // chargementComplet()
    window.location.href = "/MesInformations/MonAG/" + this.state.NumReunion;

  };

  

    Saisie = () => {
      const evt = window.event;
      const { target } = evt;
      const inputTypeEvt = evt.inputType;
      if (inputTypeEvt !== 'undefined' && inputTypeEvt === 'insertFromPaste') return;
      const champsName = target.name;
      const saisie = target.value;
      this.setState({[champsName]: saisie,},);
    };

  
    render() {
      const liste = this.state.lsvotes;
      let listeNonVote=""
      let NbNonVote=0
      liste.forEach(element => {
        if (element.Vote==0 && element.TypeVote<7 &&  element.TotTan>0) {
          NbNonVote+=1
          if (element.Numero2==0) {
            listeNonVote +=`${element.Numero1}, `
          } else {
            listeNonVote +=`${element.Numero1}-${element.Numero2}, `
          }
        }
      });
      if (listeNonVote.length > 1) {listeNonVote=listeNonVote.substring(0, listeNonVote.length - 2)}

      const handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.NomSignature.length<1 || this.state.LieuSignature.length<1) {
          this.setState({erreur: true,},);
        } else {
          document.getElementById("btnSubmit").style.display = "none";
          document.getElementById("btnAnnuler").style.display = "none";
          document.getElementById("attente").style.display="block";
            validerVotes(this.state.NumReunion, this.props.NumVotant, this.state.NomSignature, this.state.LieuSignature).then((response) => {
                if (response.status == 200) {
                    this.setState({ Fait: true, },);
                } else {
                    swal( 'Erreur', "Action non autorisée en mode visualisation.",'error', );
                }
            if (this.state.erreur === true) {this.setState({erreur: false,},)}
            document.getElementById("attente").style.display="none";
            setTimeout(() => {
              this.reinit()
            }, "6000");            
          });
        }
      }
    
        return (
          <div className="container col-xl-8">
            <div className={` card mb-3`}>
              <form onSubmit={handleSubmit} >
              {NbNonVote>0 ? 
                <div className="acc-flex-col-md-6" >
                  <div className="card mb-3 acc-valide-alert">
                    <span ><h6 className="text-left small">
                    <i className="fa fa-exclamation-triangle fa-lg acc-ico-alert" title="danger" />
                    <b>VOUS N'AVEZ PAS VOT&Eacute; A TOUTES LES QUESTIONS !</b></h6></span>
                    <div className="small td-decale"> Question{NbNonVote>1 ? 's' : null} restée{NbNonVote>1 ? 's' : null} sans vote : {listeNonVote} </div>                            
                    <div className="small td-decale"> Si vous validez le formulaire en l'état, vous ne pourrez ni le modifier ni le compléter. </div>                            
                  </div>
                </div>
              : null}
                <div className="acc-flex-col-md-6 small" >
                  <div className="card mb-3 acc-valide-form">
                    <div className="acc-padding">Je soussigné(e) : <b>{this.props.Civilite} {this.props.Nom}</b></div> 
                    <div className="acc-padding">domicilié(e) au : {this.props.Adresse.Ad1} {this.props.Adresse.Ad2} {this.props.Adresse.Cp} {this.props.Adresse.Ville}</div>
                    <div className="acc-padding">après avoir pris connaissance de l'ordre du jour et des documents annexés à la convocation 
                    ou mis à disposition sur le site en ligne sécurisé de la copropriété,&nbsp;
                    souhaite émettre sur chacune des questions soumises à la délibération de l'{this.props.Reunion.Libelle} des copropriétaires 
                    convoquée le {toDate(this.props.Reunion.DateDebut, 'DD/MM/YYYY')},&nbsp;
                    {this.props.Reunion.Adresse.Ad1} {this.props.Reunion.Adresse.Ad2}  {this.props.Reunion.Adresse.Cp} {this.props.Reunion.Adresse.Ville},&nbsp;
                     à {toDate(this.props.Reunion.DateDebut, 'hh:mm')} les votes exprimés dans le tableau ci-joint <sup>(1)</sup>.</div>
                     {this.state.Fait<1 ?
                     <section>
                    <div className="acc-padding">Fait à : 
                      <input
                          type="text"
                          className="m-1 h-75 w-50"
                          id="LieuSignature"
                          name="LieuSignature"
                          value={this.state.LieuSignature}
                          onChange={() => {this.Saisie()}}
                          maxLength={45}
                        /><sup style={{color:"red"}}>*</sup>
                    </div>
                    <div className="acc-padding">
                      le {toDate(Date(), 'DD/MM/YYYY')} à {toDate(Date(), 'HH:mm')} <sup>(2)</sup></div>
                    <div className="acc-padding">
                      Nom du signataire : 
                    <input
                          type="text"
                          className="m-1 h-75 w-50"
                          id="NomSignature"
                          name="NomSignature"
                          value={this.state.NomSignature}
                          onChange={() => {this.Saisie()}}
                          maxLength={45}
                        /><sup style={{color:"red"}}>*</sup>
                    </div>
                    </section>: null}
                    <div className="acc-padding small"><sup>(1)</sup> : tableau reprenant les votes saisis précédemment
                    {this.state.Fait<1 ?<span><br/><sup>(2)</sup> : Heure de métropole</span>: null}</div>
                  {this.state.erreur ? 
                    <div className="acc-flex-col-md-6" >
                      <div className="card mb-3 acc-valide-erreur">
                        <span ><h6 className="text-left small">
                        <i className="fa fa-exclamation-triangle fa-lg acc-ico-erreur" title="danger" />
                        <b>Tous les champs doivent être renseignés</b></h6></span>
                      </div>
                    </div>
                  : null}
                  {this.state.Fait>0 ? 
                    <div className="acc-flex-col-md-6" >
                      <div className="card mb-3 acc-valide-ok">
                        <span ><h6 className="text-left small">
                        <i className="fa fa-info-circle fa-lg acc-ico-ok" title="Votes validé" />
                        <b>Vos votes sont validés. Vous allez être redirigé vers la liste des questions</b></h6></span>
                      </div>
                    </div>
                  : null}
                  </div>
                  <div className="acc-flex-col-md-6" id='attente' style={{display:'none'}} >
                      <div className="card mb-3 acc-valide-attente">
                        <span ><h6 className="text-left small">
                        {/* <i className="fa fa-info-circle fa-lg acc-ico-attente" title="Votes validé" /> */}
                        <div class="spinner-border text-info" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                        &nbsp;&nbsp;&nbsp;
                        <b> Votes en cours de validation</b></h6></span>
                      </div>
                    </div>

                </div>

                {this.state.Fait<1 ? 
                <div className="row">
                  <div className="col-12 col-md-12 col-xl-12 text-center">
                    <button className="btn btn-success mb-1 " type="submit" id="btnSubmit" style={{width:"150px"}}>Confirmer</button>&nbsp;
                      <Link  id="btnAnnuler"
                          to={`/MesInformations/MonAG/${this.state.NumReunion}`}
                          className="btn btn-outline-primary mb-1" style={{width:"150px"}}
                          >Revoir mes votes</Link>
                  </div>
                </div>
                : 
                <div className="row">
                  {/* <div className="col-12 col-md-6 col-xl-6 ">&nbsp;</div> */}
                  <div className="col-12 col-md-12 col-xl-12 text-center">
                      <Link
                          // to={"#"} onClick={() => this.reinit() }
                          to={`/MesInformations/MonAG/${this.state.NumReunion}`}
                          className="btn btn-outline-primary mb-1"
                          >Retour à la liste des votes</Link>
                  </div>
                </div>
                
                }
                  </form>
              </div>
            </div>
        );
    };
}
FicheSignature.displayName = 'FicheSignature';

function mapStateToProps({ 
  CopStore: {
      Cop: { LsReunions },
  },
  VoteStore: { NumReuSel, Votant },
  ProStore: {
    Pro: {
        Ind: {
            Civilite, Nom, Adresse,
        },
    },
  },

}) {
  return {NumReuSel, LsReunions, Civilite, Nom, Adresse,
};
}


function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(VotesAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(FicheSignature);



// WEBPACK FOOTER //
// ./src/components/MonAG/FicheSignature.js